import React, { useState } from 'react';
import { getErrorMessage } from '../utils/errorHandler';

interface MasterImportProps {
    onMenuSelect: (menuId: string) => void;
    tenantName: string;
    currentUser: any;
    apiFetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
    currentTenantId: number | null;
}

const MasterImport: React.FC<MasterImportProps> = ({
    onMenuSelect,
    tenantName,
    currentUser,
    apiFetch,
    currentTenantId,
}) => {
    const [file, setFile] = useState<File | null>(null);
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState<{ success: boolean; message: string; errors?: string[] } | null>(null);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            setFile(e.target.files[0]);
            setResult(null);
        }
    };

    const handleUpload = async () => {
        if (!file || !currentTenantId) return;

        setLoading(true);
        setResult(null);

        const formData = new FormData();
        formData.append('file', file);

        try {
            const res = await apiFetch('/api/kamoku_import', {
                method: 'POST',
                body: formData,
                // Content-Type header should be omitted for FormData to let browser set boundary
            });

            const data = await res.json();
            if (res.ok && data.success) {
                setResult({ success: true, message: data.message });
            } else {
                setResult({
                    success: false,
                    message: data.message || "インポートに失敗しました",
                    errors: data.errors
                });
            }
        } catch (e: any) {
            setResult({ success: false, message: e.message });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto', backgroundColor: '#fff', border: '2px solid #ccc' }}>
            <div style={{ marginBottom: '20px' }}>
                <h3>勘定科目マスタCSVインポート</h3>
                <p style={{ fontSize: '12px', color: '#666' }}>
                    CSVファイルのフォーマット: 科目コード, 科目名, 大区分コード<br />
                    ※ 1行目はヘッダーとしてスキップされます。<br />
                    ※ 大区分コードは既存のものと一致する必要があります。
                </p>
                <div style={{ margin: '20px 0', border: '1px dashed #ccc', padding: '20px', textAlign: 'center' }}>
                    <input
                        type="file"
                        accept=".csv"
                        onChange={handleFileChange}
                        disabled={loading}
                    />
                </div>
                <div style={{ textAlign: 'center' }}>
                    <button
                        onClick={handleUpload}
                        disabled={!file || loading}
                        style={{
                            padding: '8px 20px',
                            fontSize: '14px',
                            cursor: (!file || loading) ? 'not-allowed' : 'pointer'
                        }}
                    >
                        {loading ? 'インポート中...' : 'アップロード実行'}
                    </button>
                </div>
            </div>

            {result && (
                <div style={{
                    marginTop: '20px',
                    padding: '15px',
                    backgroundColor: result.success ? '#d4edda' : '#f8d7da',
                    border: `1px solid ${result.success ? '#c3e6cb' : '#f5c6cb'}`,
                    color: result.success ? '#155724' : '#721c24'
                }}>
                    <strong>{result.message}</strong>
                    {result.errors && result.errors.length > 0 && (
                        <ul style={{ marginTop: '10px', fontSize: '12px' }}>
                            {result.errors.map((err, i) => <li key={i}>{err}</li>)}
                        </ul>
                    )}
                </div>
            )}
        </div>
    );
};

export default MasterImport;
